
export const text = `
[ID: A photo of a kiosk in a mall food court. Its upper sign reads “Barney’s Bangin’ Burgers!” in a stylized font, patterned with red LEDs. Its logo appears to be an Escher-esque, impossible cube rendition of a cheeseburger. There is a sizable banner promoting the store next to it: ‘Free Minoburger for every 3.5 hours spent in the mall!’ The only person in the picture is a janitor, who is sweeping the floor nearly out of frame.]



`